import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { useTranslation } from 'react-i18next';
import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from '@@components/ProtectedRoute';
import { reactPlugin } from '@@config/appInsights';
import { LocatePage } from '@@locate/LocatePage';
import { PaymentSuccessfulPage } from '@@payment/PaymentSuccessfulPage';
import { TrackPage } from '@@track/TrackPage';

interface Props {
  mode: 'track' | 'locate';
}

export function App({ mode }: Props) {
  const { t } = useTranslation();

  return (
    <AppInsightsErrorBoundary
      onError={() => <h1>{`${t('tryAgainErrorMessage')} ${t('errorPersistMessage')}.`}</h1>}
      appInsights={reactPlugin}
    >
      <Routes>
        <Route path="/payment-success" element={<PaymentSuccessfulPage />} />

        <Route
          path="/"
          element={<ProtectedRoute>{mode === 'locate' ? <LocatePage /> : <TrackPage />}</ProtectedRoute>}
        />

        <Route
          path="/:id"
          element={<ProtectedRoute>{mode === 'locate' ? <LocatePage /> : <TrackPage />}</ProtectedRoute>}
        />
      </Routes>
    </AppInsightsErrorBoundary>
  );
}
